import { render, staticRenderFns } from "./bankDetailsEmpty.vue?vue&type=template&id=4c19acdd"
import script from "./bankDetailsEmpty.vue?vue&type=script&lang=js"
export * from "./bankDetailsEmpty.vue?vue&type=script&lang=js"
import style0 from "./bankDetailsEmpty.vue?vue&type=style&index=0&id=4c19acdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports